import React from 'react';
import PropTypes from 'prop-types';

/**
 * Possible status types
 *
 * @type {object}
 */
const STATUS = {
  Incomplete: 'incomplete',
  Current: 'current',
  Complete: 'complete'
};

/**
 * ProgressStep component, representing each individual step.
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
function ProgressStep(props) {
  return (
    <li role='status' aria-live='polite' aria-label={ `step ${props.status}` } className={ `ux-tabs-wiz-step-${props.status}` }>
      <a href={ props.href } onClick={ props.onClick }>
        <span className='ux-tabs-wiz-txt'>{ props.children }</span>
      </a>
    </li>
  );
}

ProgressStep.propTypes = {
  status: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
};

ProgressStep.defaultProps = {
  status: STATUS.Incomplete
};

ProgressStep.Status = STATUS;

export {
  ProgressStep as default
};



// WEBPACK FOOTER //
// ./node_modules/@ux/progress-steps/progress-step.js